"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const RecordingUsage_1 = __importDefault(require("@Components/MatchComponents/MatchRecordingGroups/MatchingRecordingGroupsTable/RecordingUsage"));
const common_1 = require("@Const/common");
const MatchDetailsTable_1 = __importDefault(require("@Components/MatchComponents/MatchDetailsTable"));
const clsx_1 = __importDefault(require("clsx"));
const MatchRecordingGroupsRow = (props) => {
    const { result, selected, deselect, select } = props;
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "results-row" },
            react_1.default.createElement("p", null, result.isrc),
            react_1.default.createElement("p", null, result.title),
            react_1.default.createElement("p", null, result.artist),
            react_1.default.createElement("p", null, result.writers),
            react_1.default.createElement(RecordingUsage_1.default, { recordings: result.recordings, recordingGroupId: result.id }),
            react_1.default.createElement("p", null, '$'.repeat(result.unmatchedAmount)),
            react_1.default.createElement("div", { className: "icons" },
                react_1.default.createElement("img", { className: (0, clsx_1.default)(isExpanded ? 'chevron-icon-expanded' : 'chevron-icon'), src: common_1.ICONS.chevron_drop_down, onClick: () => setIsExpanded(!isExpanded), alt: isExpanded ? 'contract' : 'expand' }),
                selected ? (react_1.default.createElement("img", { className: "select-icon", src: common_1.ICONS.check, onClick: () => deselect(result.id), alt: 'deselect' })) : (react_1.default.createElement("div", { className: "no-select", "data-testid": 'select-rg-button', onClick: () => select(result.id) })))),
        isExpanded && (react_1.default.createElement("div", { className: "expand-details", key: `${result.id}-details` },
            react_1.default.createElement(MatchDetailsTable_1.default, { recordings: result.recordings })))));
};
exports.default = MatchRecordingGroupsRow;
